import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Button, Alert } from "react-bootstrap";
import "./ContactForm.scss";

export default function ContactForm(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleChange = (e) => {
    if (e.target.id === "name") setName(e.target.value);
    if (e.target.id === "email") setEmail(e.target.value);
    if (e.target.id === "subject") setSubject(e.target.value);
    if (e.target.id === "message") setMessage(e.target.value);
  };

  const sendMessage = async () => {
    if (!name || !email || !subject || !message) {
      return;
    }
    setIsSubmitting(true);
    setHasError(false);

    const data = {
      "customer-id": props.customer_id,
      name: name,
      email: email,
      subject: subject,
      message: message
    };

    try {
      const response = await fetch("https://api.wdttx.com/prod/contact-us", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
      const r = await response.json();
      if (r["statusCode"] === 200 || response.ok) {
        setMessageSent(true);
      } else {
        setHasError(true);
      }
    } catch (error) {
      setHasError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form">
      <Form id="contact-form" onSubmit={(e) => { e.preventDefault(); sendMessage(); }}>
        <Form.Group className="py-2">
          <Form.Control
            type="text"
            placeholder="Your Name"
            name="name"
            value={name}
            onChange={handleChange}
            id="name"
            required
          />
        </Form.Group>

        <Form.Group className="py-2">
          <Form.Control
            type="email"
            placeholder="Your Email"
            name="email"
            value={email}
            onChange={handleChange}
            id="email"
            required
          />
        </Form.Group>

        <Form.Group className="py-2">
          <Form.Control
            type="text"
            placeholder="Subject"
            name="subject"
            value={subject}
            onChange={handleChange}
            id="subject"
            required
          />
        </Form.Group>

        <Form.Group className="py-2">
          <Form.Control
            as="textarea"
            rows={6}
            placeholder="Message"
            name="message"
            value={message}
            onChange={handleChange}
            id="message"
            required
          />
        </Form.Group>

        <Alert variant="success" show={messageSent} className="mt-3">
          Thank you! Your message was delivered successfully. We will contact you as soon as possible.
        </Alert>

        <Alert variant="danger" show={hasError} className="mt-3">
          Sorry, something went wrong. Please try again later or email us directly at contact@wdttx.com.
        </Alert>

        {!messageSent && (
          <Button
            id="link_send_message"
            size="lg"
            variant="primary"
            className="mt-4"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Submit"}
          </Button>
        )}
      </Form>
    </div>
  );
}
